import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "overrides"]

  connect() {
    if (this.hasSelectTarget && this.selectTarget.value) {
      this.showOverrides()
    }
  }

  toggleOverrides() {
    if (this.hasSelectTarget && this.selectTarget.value) {
      this.showOverrides()
    } else {
      this.hideOverrides()
    }
  }

  showOverrides() {
    if (this.hasOverridesTarget) {
      this.overridesTarget.classList.remove('hidden')
    }
  }

  hideOverrides() {
    if (this.hasOverridesTarget) {
      this.overridesTarget.classList.add('hidden')
    }
  }
} 